import { FC, useEffect } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps } from ".";
import UuidControlViewModel from "../Models/UuidControlViewModel";

interface IUuidControlProps extends IFormProps {
	model: UuidControlViewModel;
};

const UuidControl: FC<IUuidControlProps> = ( { model, readOnly, setFieldValue } ) => {

	const [ inputProps,,helperProps ] = useField( model.FullPath );

	useEffect( () => {
		helperProps.setValue( model.Value, true );
	// eslint-disable-next-line
	}, [ model.Value ] );

	const onChangeValue = ( value: any ) => setFieldValue( model.FullPath, value );

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling || readOnly }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<input 
				{...inputProps}
				readOnly={ !model.ControlEnabling || readOnly }
				type="text"
				value = { inputProps.value || model.DefaultValue || "" }
				onChange={ e => onChangeValue(e.target.value)}
			/>
		</FieldGroup>
	);
};

export default UuidControl;
